import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import HttpPlugin from './plugins/http';

import 'babel-polyfill';
import './plugins/ant-design-vue';
// import './plugins/vue-charts';
// import './plugins/amap';
import './plugins/vuebar';
import './plugins/filters';
import './plugins/components';
import './plugins/directives';
import './styles/common.less';
import $ from 'jquery'

// eslint-disable-next-line import/order
import VueCoreVideoPlayer from 'vue-core-video-player';

import Video from 'video.js';
import 'video.js/dist/video-js.css';

import vueFlvPlayer from 'vue-flv-player';

Vue.use(VueCoreVideoPlayer, {
    lang: 'zh-CN',
});
Vue.use(vueFlvPlayer);


Vue.prototype.$video = Video; // 引入Video播放器
// Vue.use(DPlayer);
Vue.use(HttpPlugin, {
    router,
    store,
});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');